var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChinaFutureTechIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 80,
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15857_122756)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_15857_122756)"
}, /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M-10.9169 68.2867C4.70518 68.2867 17.3694 55.6226 17.3694 40.0005C17.3694 24.3784 4.70518 11.7142 -10.9169 11.7142C-26.5389 11.7142 -39.2031 24.3784 -39.2031 40.0005C-39.2031 55.6226 -26.5389 68.2867 -10.9169 68.2867Z",
  fill: "#FFCA05"
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M90.9151 68.2867C106.537 68.2867 119.201 55.6226 119.201 40.0005C119.201 24.3784 106.537 11.7142 90.9151 11.7142C75.2931 11.7142 62.6289 24.3784 62.6289 40.0005C62.6289 55.6226 75.2931 68.2867 90.9151 68.2867Z",
  fill: "#FFCA05"
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M68.2873 90.9157C68.2873 75.2937 55.6232 62.6295 40.0011 62.6295C24.379 62.6295 11.7148 75.2937 11.7148 90.9157C11.7148 106.538 24.379 119.202 40.0011 119.202C55.6232 119.202 68.2873 106.538 68.2873 90.9157Z",
  fill: "#FFCA05"
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M68.2873 -10.9142C68.2873 -26.5363 55.6232 -39.2005 40.0011 -39.2005C24.379 -39.2005 11.7148 -26.5363 11.7148 -10.9142C11.7148 4.70783 24.379 17.372 40.0011 17.372C55.6232 17.372 68.2873 4.70783 68.2873 -10.9142Z",
  fill: "#FFCA05"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9014 27.5789C18.4012 31.0787 24.0754 31.0787 27.5751 27.5789C31.0749 24.0792 31.0749 18.4049 27.5751 14.9052C24.0754 11.4054 18.4012 11.4054 14.9014 14.9052C11.4017 18.4049 11.4017 24.0792 14.9014 27.5789Z",
  fill: "#FFCA05"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M52.5672 64.9506C55.9862 68.3696 61.5294 68.3696 64.9484 64.9506C68.3674 61.5316 68.3674 55.9884 64.9484 52.5694C61.5294 49.1504 55.9862 49.1504 52.5672 52.5694C49.1482 55.9884 49.1482 61.5316 52.5672 64.9506Z",
  fill: "#FFCA05"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5746 65.0954C31.0746 61.5954 31.0746 55.9207 27.5746 52.4207C24.0745 48.9207 18.3999 48.9207 14.8999 52.4207C11.3998 55.9207 11.3998 61.5954 14.8999 65.0954C18.3999 68.5954 24.0745 68.5954 27.5746 65.0954Z",
  fill: "#FFCA05"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M65.0919 27.5778C68.5908 24.0789 68.5908 18.406 65.0919 14.9071C61.593 11.4082 55.9202 11.4082 52.4213 14.9071C48.9224 18.406 48.9224 24.0789 52.4213 27.5778C55.9202 31.0767 61.593 31.0767 65.0919 27.5778Z",
  fill: "#FFCA05"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M59.7998 20.1997V59.8003H20.1992V20.1997H59.7998ZM25.959 54.0406H54.04V25.9595H25.959V54.0406Z",
  fill: "#4585FF"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15857_122756"
}, /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 80,
  rx: 40,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_15857_122756"
}, /*#__PURE__*/React.createElement("rect", {
  width: 95.9999,
  height: 95.9999,
  fill: "white",
  transform: "translate(-8 -7.99942)"
})))));
export default SvgChinaFutureTechIcon;